<div style="display: flex; align-items: center; gap: 12px; background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px 14px; transition: all 0.2s ease;"
  class="hover:border-green-300 hover:shadow-md">
  <img [src]="imgUrl" style="width: 40px; height: 40px; object-fit: contain; border-radius: 8px;">
  <div style="display: flex; flex-direction: column;">
    <span *ngIf="rateOrigin" style="font-size: 0.95rem; font-weight: 800; color: #1e5a3f;">{{ rateOrigin | number:'1.2-6' }}</span>
    <span style="font-size: 0.85rem; font-weight: 700; color: #374151;">{{ rateDestination | number:'1.2-5' }}</span>
    <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500;">{{ bank }}</span>
  </div>
</div>
